import { mask } from 'react-native-mask-text';
import { PHONE_MASK, INTL_PHONE_MASK } from 'src/constants';

const formatPhoneNumber = (phoneNumber: string | undefined): string =>
  mask((phoneNumber ?? '').replace(/[^\d]/g, ''), [PHONE_MASK, INTL_PHONE_MASK]);

export default formatPhoneNumber;
